import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#242433",
  "fill-rule": "evenodd",
  d: "M21.083 11c0 5.569-4.514 10.083-10.083 10.083S.917 16.57.917 11 5.43.917 11 .917 21.083 5.43 21.083 11M11 19.25a8.25 8.25 0 1 0 0-16.5 8.25 8.25 0 0 0 0 16.5m3.667-7.333a.917.917 0 1 0 0-1.834H7.333a.917.917 0 1 0 0 1.834z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }